import translates from './es.json';
import restNotifications from './notifiers.json';

export default {
  es: { ...translates, ...restNotifications },
};
